module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_7042.8b4383ab.png";